import React from "react";
import ClipLoader from "react-spinners/ClipLoader";

const SpinnerLoading: React.FC = () => {
    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
            <ClipLoader size={50} color="#123abc" />
        </div>
    );
};

export default SpinnerLoading;